module.exports = "//imgak.mmtcdn.com/rails_cdn_dt/static/media/ty_pending.36e10245.png";